export { useWatchTheatricalContext, WatchTheatricalContextProvider } from './WatchTheatricalContext'
